module.exports = __webpack_public_path__ + "img/chance.2a8101d3.png";